import React from 'react';
import { Box, Tooltip, Typography } from '@mui/material';
import { makeStyles } from 'tss-react/mui';
import { InfoOutlined } from '@mui/icons-material';
import { Navigation, NavigationLinks, NavigationProps, NavigationSection } from '../../components';

const useStyles = makeStyles()(theme => ({
  titleRoot: {
    display: 'flex',
    gap: theme.spacing(1),
    alignItems: 'center',
  },
  title: {
    fontSize: '18px',
    lineHeight: '18px',
    color: theme.palette.darkSlate.main,
  },
  titleTooltip: {
    fontSize: '14px',
  },
  tooltipIcon: {
    color: theme.palette.text.secondary,
  }
}));


export type ProviderDialogNavigationProps = {
  title?: React.ReactNode;
  titleTooltip?: React.ReactNode;
  leftActions?: React.ReactElement;
  rightActions?: React.ReactElement;
  variant?: NavigationProps['variant'];
  position?: NavigationProps['position'];
};


export const ProviderDialogNavigation: React.FC<ProviderDialogNavigationProps> = ({
  leftActions,
  rightActions,
  title,
  titleTooltip,
  variant = 'elevation',
  position = 'static',
}) => {
  const { classes } = useStyles();

  const titleElement = React.useMemo(() => {
    if (typeof title === 'string') {
      return (
        <Typography className={classes.title} variant="h6">{title}</Typography>
      );
    }

    return title;
  }, [ title, classes.title ]);

  return (
    <Navigation variant={variant} position={position}>
      <NavigationSection alignment="start" vertical="center">
        {leftActions}
      </NavigationSection>

      <NavigationSection alignment="center" vertical="center">
        <Box className={classes.titleRoot}>
          {titleElement}
          {titleTooltip && (
            <Tooltip
              title={titleTooltip}
              placement="right"
              arrow
              classes={{
                tooltip: classes.titleTooltip
              }}
            >
              <InfoOutlined className={classes.tooltipIcon} />
            </Tooltip>
          )}
        </Box>
      </NavigationSection>

      <NavigationSection alignment="end" vertical="center">
        <NavigationLinks>
          {rightActions}
        </NavigationLinks>
      </NavigationSection>
    </Navigation>
  );
};
